export const errorCannotCompleteRequestLineOne = "RkQZ5c";
export const errorCannotCompleteRequestLineTwo = "rAfX8c";
export const safeToCloseString = "j0o$kb";
export const nothingIsSelected = "UgwMAc";
export const errorMessageNotFound = "oaUjle";
export const goToInboxString = "sdte8";
export default {errorCannotCompleteRequestLineOne,errorCannotCompleteRequestLineTwo,safeToCloseString,nothingIsSelected,errorMessageNotFound,goToInboxString};